/* eslint-disable default-case */
/* global Liferay */

import {
	getNextLessonLocalStorage,
	getPreviousLessonLocalStorage,
} from "../../utils/util";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { getCurrentLanguageKey } from "../../utils/util";
import { useTranslation } from "react-i18next";
import ClayLoadingIndicator from "@clayui/loading-indicator";
import { getQuestions, getQuizByDPAAssetId, postQuizResult } from "../../services/exercise";
import {
	enrollToCourse,
	getCourseByAssetTypeAndId,
} from "../../services/course";
import {
	getUserEnrollmentByCourseId,
	updateUserEnrollmentByEnrollmentId,
} from "../../services/enrollment";
import QuizHome from "./QuizHome";
import QuizProgressBar from "./QuizProgressBar";
import QuizResultSheet from "./QuizResultSheet";
import QuizQuestions from "./QuizQuestions";
import {
	getBadgeById,
	getUserBadgeByUserIdAndQuizId,
} from "../../services/badge";
import { getBadgeByQuizId } from "../../services/badge";
import { RELATIONSHIP } from "../../utils/constants";

const parseAnswers = (answers) => {
	return JSON.parse(answers);
};

const ExerciseView = forwardRef((props, ref) => {
	const {
		exerciseId,
		height,
		educationPageUrl,
		badgePageUrl,
		enableBackButton,
	} = props;

	const {  i18n: { changeLanguage } } = useTranslation();

	const [active, setActive] = useState(-1);
	const [answers, setAnswers] = useState(null);
	const [assetId, setAssetId] = useState(null);
	const [firstQuestion, setFirstQuestion] = useState(false);
	const [isKnoledgeCheck, setIsKnoledgeCheck] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [moduleInfo, setModuleInfo] = useState({});
	const [nextLesson, setNextLesson] = useState(null);
	const [prevLesson, setPrevLesson] = useState(null);
	const [progress, setProgress] = useState(0);
	const [questions, setQuestions] = useState(null);
	const [scoreSheetOverall, setScoreSheetOverall] = useState(null);
	const [showError, setShowError] = useState(false);
	const { linkPrefix } = props;
	const [courseId, setCourseId] = useState(null);
	const [isEnrolled, setIsEnrolled] = useState(false);
	const [userEnrollmentId, setUserEnrollmentId] = useState(null);
	const [completedAssetIds, setCompletedAssetsIds] = useState("");
	const [badgeId, setBadgeId] = useState(null);
	const [currentBadge, setCurrentBadge] = useState({});
	const [userBadgeData, setUserBadgeData] = useState([]);
	const [userBadgeYear, setUserBadgeYear] = useState(null);
	const [userBadgeMonth, setUserBadgeMonth] = useState(null);

	const currentQuizzId = exerciseId;

	const fetchUserEnrollment = async () => {
		const result = await getUserEnrollmentByCourseId(courseId);

		setUserEnrollmentId(result?.items?.length > 0 ? result.items[0].id : "");
		setCompletedAssetsIds(
			result?.items?.length > 0 ? result.items[0].completedAssetIds : []
		);
	};

	useEffect(() => {
		const fetchBadgeByQuizId = async () => {
			const badgeIdByQuiz = await getBadgeByQuizId(currentQuizzId);

			setBadgeId(badgeIdByQuiz);

			setCurrentBadge(await getBadgeById(badgeIdByQuiz));
		};
		fetchBadgeByQuizId();
	}, [currentQuizzId]);

	useEffect(() => {
		const fetchCourseId = async () => {
			const response = await getCourseByAssetTypeAndId(RELATIONSHIP.MODULES_TO_QUIZZES, currentQuizzId);
			setCourseId(response);
		};

		fetchCourseId();
	}, [currentQuizzId]);

	useEffect(() => {
		if (courseId) {
			fetchUserEnrollment();
		}
	}, [courseId]);

	useEffect(() => {
		if (userEnrollmentId) {
			setIsEnrolled(true);
		}
	}, [userEnrollmentId, courseId]);

	const handleRegisterUserAndUpdateEnrollment = async () => {
		if (!isEnrolled) {
			await enrollToCourse(courseId);
			fetchUserEnrollment();
		}

		updateUserEnrollmentByEnrollmentId(userEnrollmentId, true);

		setFirstQuestion(true);
	};

	const prepareAnswersObject = (quizQuestions) => {
		let answersObject = {};

		quizQuestions.forEach((question) => {

			switch (question.questionType.key) {
				case "selectSingleChoice": {
					answersObject[question.id] = {};

					answersObject[question.id] = null;

					break;
				}

				case "selectMultipleChoice": {
					answersObject[question.id] = {};

					quizQuestions.p2s3QuizQuestionToP2S3QuizAnswers?.forEach((quizAnswer) => {
						answersObject[question.id][quizAnswer.id] = false;
					
						<QuizProgressBar
							active={active}
							questions={quizQuestions}
							progress={progress}
						/>;
					});

					break;
				}
				case "freeText": {
					answersObject[question.id] = "";

					break;
				}
			}
		});

		setAnswers(JSON.stringify(answersObject));
	};

	const handleClearAnswers = useCallback(() => {
		prepareAnswersObject(questions);
	}, [questions]);

	const validateCurrentQuestion = useCallback(
		(questions) => {
			let currentQuestion = questions[active];

			let isValid = false;

			let currentAnswers = parseAnswers(answers);

			switch (currentQuestion.questionType.key) {
				case "selectSingleChoice": {
					isValid =
						currentAnswers[currentQuestion.id] &&
						currentAnswers[currentQuestion.id] !== "";
					break;
				}

				case "selectMultipleChoice": {
					if (!currentAnswers[currentQuestion.id]) {
						isValid = false;
					} else {
						const answerKeys = Object.keys(currentAnswers[currentQuestion.id]);

						isValid = answerKeys.some(
							(key) => currentAnswers[currentQuestion.id][key]
						);
					}

					break;
				}

				case "freeText": {
					isValid =
						currentAnswers[currentQuestion.id] &&
						currentAnswers[currentQuestion.id].length > 0
							? true
							: false;

					break;
				}
			}

			setShowError(!isValid);

			return isValid;
		},
		[active, answers]
	);

	const getUserBadge = async (exerciseResult) => {
		if (exerciseResult?.passed) {
			const data = await getUserBadgeByUserIdAndQuizId(currentQuizzId);

			setUserBadgeData(data);

			if (userBadgeData.items && userBadgeData.items.length > 0) {
				const userBadgeDate = userBadgeData.items[0].dateCreated;

				const date = new Date(userBadgeDate);

				setUserBadgeYear(date.getFullYear());
				setUserBadgeMonth(date.getMonth() + 1);
			} else {
				const date = new Date();

				const currentYear = date.getFullYear();
				const currentMonth = date.getMonth() + 1;

				setUserBadgeYear(currentYear);
				setUserBadgeMonth(currentMonth);
			}
		}
	};

	const handleSubmit = useCallback(async () => {
		if (!validateCurrentQuestion(questions)) {
			return;
		}

		setActive((prevActive) => {
			if (prevActive + 1 < questions.length) {
				return prevActive + 1;
			}
			return prevActive;
		});

		setIsLoading(true);

		const exerciseResult = await postQuizResult(assetId, parseAnswers(answers));

		setScoreSheetOverall(exerciseResult);

		getUserBadge(exerciseResult);

		setIsLoading(false);
	}, [questions, validateCurrentQuestion]);

	const handleNextQuestion = useCallback(() => {
		if (!validateCurrentQuestion(questions)) {
			return;
		}

		setActive((prevActive) => {
			if (prevActive + 1 < questions.length) {
				return prevActive + 1;
			}
			return prevActive;
		});
	}, [questions, validateCurrentQuestion]);

	const handlePreviousQuestion = useCallback(() => {
		if (active - 1 >= 0) {
			setActive(active - 1);
		}
	}, [active, questions]);

	const handleQuizReset = () => {
		handleClearAnswers();
		setActive(0);
		setProgress(0);
		setScoreSheetOverall(null);
	};

	useEffect(() => {
		if (exerciseId && exerciseId.toString().length > 0) {
			getQuestions(exerciseId).then((result) => {
				setQuestions(result);

				prepareAnswersObject(result);

				setActive(0);
			});
		}
	}, []);

	useEffect(() => {
		if (questions && questions.length > 0) {
			let currentProgress = 0;

			currentProgress = ((active + 1) / questions.length) * 100;

			setProgress(currentProgress);
		}
	}, [active, questions]);

	useEffect(() => {
		changeLanguage(getCurrentLanguageKey()).then(() => {});
		if (exerciseId && exerciseId.toString().length > 0) {
			setAssetId(exerciseId);
		}
	}, [changeLanguage]);

	useEffect(() => {
		const fetchData = async () => {
				getQuizByDPAAssetId(exerciseId).then((response) => {
					setIsKnoledgeCheck(response.isKnowledgeCheck);
					setModuleInfo({ passingScore: response.passingScore });
				});
		};
		fetchData().catch(console.error);
	}, []);

	useEffect(() => {
		if (scoreSheetOverall) {
			const titleDuration = document.querySelector(".title-duration");
			if (titleDuration) {
				titleDuration.style.display = "none";
			}
		}

		return () => {
			const titleDuration = document.querySelector(".title-duration");
			if (titleDuration) {
				titleDuration.style.display = "";
			}
		};
	}, [scoreSheetOverall]);

	useEffect(() => {
		Liferay.once("lessonNavigationUpdated", (event) => {
			setNextLesson(getNextLessonLocalStorage(currentQuizzId));
			setPrevLesson(getPreviousLessonLocalStorage(currentQuizzId));
		});
	}, [currentQuizzId]);

	return (
		<div>
			{isLoading && <ClayLoadingIndicator displayType="secondary" size="sm" />}

			{questions && !scoreSheetOverall && (
				<>
					{!firstQuestion && (
						<QuizHome
							completedAssetIds={completedAssetIds}
							courseId={courseId}
							currentQuizzId={currentQuizzId}
							firstQuestion={firstQuestion}
							handleRegisterUserAndUpdateEnrollment={
								handleRegisterUserAndUpdateEnrollment
							}
							isEnrolled={isEnrolled}
							isKnoledgeCheck={isKnoledgeCheck}
							linkPrefix={linkPrefix}
							moduleInfo={moduleInfo}
							nextLesson={nextLesson}
							prevLesson={prevLesson}
							progress={progress}
							questions={questions}
							setFirstQuestion={setFirstQuestion}
							userEnrollmentId={userEnrollmentId}
						/>
					)}

					{firstQuestion && (
						<QuizQuestions
							active={active}
							answers={answers}
							enableBackButton={enableBackButton}
							handleNextQuestion={handleNextQuestion}
							handlePreviousQuestion={handlePreviousQuestion}
							handleSubmit={handleSubmit}
							height={height}
							isLoading={isLoading}
							parseAnswers={parseAnswers}
							progress={progress}
							questions={questions}
							setAnswers={setAnswers}
							showError={showError}
						/>
					)}
				</>
			)}

			{scoreSheetOverall && (
				<QuizResultSheet
					badgeId={badgeId}
					badgePageUrl={badgePageUrl}
					completedAssetIds={completedAssetIds}
					courseId={courseId}
					currentBadge={currentBadge}
					currentQuizzId={currentQuizzId}
					educationPageUrl={educationPageUrl}
					handleReset={handleQuizReset}
					isEnrolled={isEnrolled}
					isKnowledgeCheck={isKnoledgeCheck}
					linkPrefix={linkPrefix}
					nextLesson={nextLesson}
					prevLesson={prevLesson}
					questions={questions}
					scoreSheetOverall={scoreSheetOverall}
					userBadgeMonth={userBadgeMonth}
					userBadgeYear={userBadgeYear}
					userEnrollmentId={userEnrollmentId}
				/>
			)}
		</div>
	);
});

export default ExerciseView;
